import React from 'react';
import Icon from '../../../components/AppIcon';

const ContactHero = () => {
  return (
    <section className="relative bg-gradient-to-br from-gray-900 via-gray-950 to-black text-white overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-20 left-10 w-32 h-32 border border-blue-500/30 rounded-full"></div>
        <div className="absolute top-40 right-20 w-24 h-24 border border-teal-500/30 rounded-full"></div>
        <div className="absolute bottom-20 left-1/4 w-16 h-16 border border-blue-500/30 rounded-full"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 lg:py-32">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="space-y-8">
            <div className="space-y-4">
              <div className="flex items-center space-x-3">
                <div className="w-3 h-3 bg-green-500 rounded-full animate-pulse-gold"></div>
                <span className="text-blue-400 font-medium">Available for New Projects</span>
              </div>
              
              <h1 className="text-4xl lg:text-6xl font-extrabold leading-tight">
                Let's Build Something
                <span className="text-teal-400 block">Amazing Together</span>
              </h1>
              
              <p className="text-xl text-gray-300 leading-relaxed">
                Whether you're looking for technical expertise, mentorship guidance, or community collaboration, I'm here to help turn your vision into reality.
              </p>
            </div>

            {/* Quick Stats */}
            <div className="grid grid-cols-3 gap-6">
              <div className="text-center">
                <div className="text-2xl font-bold text-blue-400">24h</div>
                <div className="text-sm text-gray-400">Response Time</div>
              </div>
              <div className="text-center">
                <div className="text-2xl font-bold text-blue-400">100+</div>
                <div className="text-sm text-gray-400">Projects Delivered</div>
              </div>
              <div className="text-center">
                <div className="text-2xl font-bold text-blue-400">100+</div>
                <div className="text-sm text-gray-400">Developers Mentored</div>
              </div>
            </div>

            {/* Contact Methods */}
            <div className="flex flex-wrap gap-4">
              <a
                href="mailto:devcodead0@gmail.com"
                className="flex items-center space-x-2 px-4 py-2 bg-white/10 backdrop-blur-sm rounded-lg hover:bg-white/20 transition-all duration-300"
              >
                <Icon name="Mail" size={16} />
                <span className="text-sm">devcodead0@gmail.com</span>
              </a>
              <a
                href="https://www.linkedin.com/in/ebesoh-adrian/?lipi=urn%3Ali%3Apage%3Ad_flagship3_feed%3BpzBmhJAsRZW67Ho74ZMj0w%3D%3D"
                className="flex items-center space-x-2 px-4 py-2 bg-white/10 backdrop-blur-sm rounded-lg hover:bg-white/20 transition-all duration-300"
              >
                <Icon name="Linkedin" size={16} />
                <span className="text-sm">LinkedIn</span>
              </a>
            </div>
          </div>

          {/* Right Content - Contact Options */}
          <div className="space-y-6">
            <div className="bg-white rounded-2xl p-8 border border-white/20 text-black">
              <h3 className="text-xl font-bold mb-6">How can I help you?</h3>
              
              <div className="space-y-4">
                <div className="flex items-center space-x-4 p-4 bg-gray-100 rounded-lg hover:bg-gray-200 transition-all duration-300 cursor-pointer">
                  <div className="w-12 h-12 bg-blue-500/20 rounded-lg flex items-center justify-center">
                    <Icon name="Code" size={20} className="text-blue-500" />
                  </div>
                  <div>
                    <div className="font-bold">Project Collaboration</div>
                    <div className="text-sm text-gray-600">Full-stack development & technical consulting</div>
                  </div>
                </div>

                <div className="flex items-center space-x-4 p-4 bg-gray-100 rounded-lg hover:bg-gray-200 transition-all duration-300 cursor-pointer">
                  <div className="w-12 h-12 bg-green-500/20 rounded-lg flex items-center justify-center">
                    <Icon name="Users" size={20} className="text-green-500" />
                  </div>
                  <div>
                    <div className="font-bold">Mentorship Program</div>
                    <div className="text-sm text-gray-600">1-on-1 guidance & career development</div>
                  </div>
                </div>

                <div className="flex items-center space-x-4 p-4 bg-gray-100 rounded-lg hover:bg-gray-200 transition-all duration-300 cursor-pointer">
                  <div className="w-12 h-12 bg-purple-500/20 rounded-lg flex items-center justify-center">
                    <Icon name="Mic" size={20} className="text-purple-500" />
                  </div>
                  <div>
                    <div className="font-bold">Speaking Engagement</div>
                    <div className="text-sm text-gray-600">Tech talks & community events</div>
                  </div>
                </div>

                <div className="flex items-center space-x-4 p-4 bg-gray-100 rounded-lg hover:bg-gray-200 transition-all duration-300 cursor-pointer">
                  <div className="w-12 h-12 bg-red-500/20 rounded-lg flex items-center justify-center">
                    <Icon name="Heart" size={20} className="text-red-500" />
                  </div>
                  <div>
                    <div className="font-bold">Community Partnership</div>
                    <div className="text-sm text-gray-600">Collaboration & knowledge sharing</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactHero;